
// src/actions/access-token.js

import PermanentStore from './permanent-store'

const TOKEN_KEY = 'gambaApp.authentication_token'
const accessTokenStore = PermanentStore(TOKEN_KEY)

export default {
  get: (callback)=> {
    accessTokenStore.get((token)=> {
      // sessionStorageにも同じtokenを保存しておき、
      // 現在のlocalStorageの値と比べることで、
      // 別のwindow/tabで別ユーザとしてgamba!にログインしたことを検出する
      const session_token = sessionStorage.getItem(TOKEN_KEY)
      if (session_token && session_token != token)
        token = undefined
      else if (!session_token && token)
        sessionStorage.setItem(TOKEN_KEY, token)
      callback(token)
    })
  },

  set: (token, callback)=> {
    sessionStorage.setItem(TOKEN_KEY, token)
    accessTokenStore.set(token, callback)
  },

  clear: ()=> {
    accessTokenStore.clear()
    sessionStorage.removeItem(TOKEN_KEY)
  },
}



// WEBPACK FOOTER //
// ./src/actions/access-token.js